import moment from 'moment';

// Get visible expenses

export default (expenses, { text, label, sortBy, startDate, endDate }) => {
  return expenses.filter((expense) => {
    const createdAtMoment = moment(expense.createdAt);
    const startDateMatch = startDate ? startDate.isSameOrBefore(createdAtMoment, 'day') : true;
    const endDateMatch = endDate ? endDate.isSameOrAfter(createdAtMoment, 'day') : true;
    const textMatch = expense.description.toLowerCase().includes(text.toLowerCase());
    //const labelMatch = expense.label === label ? true : false
    const labelMatch = !label ? true : expense.label ? expense.label.toLowerCase() === label.toLowerCase() : false
    //console.log('expense selector label: ', label)
    return startDateMatch && endDateMatch && textMatch && labelMatch;
  }).sort((a, b) => {
    if (sortBy === 'date') {
      return a.createdAt < b.createdAt ? 1 : -1;
    } else if (sortBy === 'dateD') {
      return a.createdAt < b.createdAt ? -1 : 1;
    } else if (sortBy === 'amount') {
      return a.amount < b.amount ? 1 : -1;
    }
  });
};



// WEBPACK FOOTER //
// ./src/selectors/expenses.js